import React from "react";

const Hero = () => {
  return (
    <div className="absolute top-0 left-0 w-full h-[180px] bg-[#020617] z-0 overflow-hidden rounded-b-[2rem] shadow-xl">
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&q=80&w=2000"
          alt="cover"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#020617]/50 to-[#020617]"></div>
    </div>
  );
};

export default Hero;

